import { CheckCircle2, Copy, KeyRound, Link2 } from "lucide-react";
import { toast } from "sonner";
import { copyText, rideLink } from "@/lib/api";
import { WhatsAppButton } from "@/components/fleet/WhatsAppButton";

export const InvitePreview = () => (
  <div data-testid="invite-link-preview" className="rounded-xl border border-[#3B82F6]/50 bg-[#3B82F6]/10 p-4 flex flex-col gap-2">
    <div className="flex items-center gap-2 text-sm">
      <Link2 size={16} className="text-[#93C5FD]" />
      <span className="ff-code ff-blur-link text-white truncate">{window.location.host}/?invite=Xk7Qp2Lm</span>
    </div>
    <div className="flex items-center gap-2 text-sm">
      <KeyRound size={16} className="text-[#93C5FD]" />
      <span className="text-[#94A3B8]">PIN</span>
      <span className="ff-code ff-blur-link text-white tracking-[0.3em]">482913</span>
    </div>
    <p className="text-xs text-[#94A3B8] leading-relaxed">Link e PIN vengono generati alla pubblicazione. La corsa resta privata: non appare sulla Live Board pubblica.</p>
  </div>
);

const copy = async (text, msg) => {
  const ok = await copyText(text);
  ok ? toast.success(msg) : toast.error("Copia non riuscita, seleziona il testo manualmente");
};

export const PublishResult = ({ ride, onDone }) => {
  const link = rideLink(ride);
  return (
    <div data-testid="publish-result" className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <CheckCircle2 size={28} className="text-[#10B981] shrink-0" />
        <p className="text-white font-semibold">{ride.invite_enabled ? "Corsa privata pubblicata. Inviala al collega di fiducia." : "Corsa pubblicata sulla Live Board."}</p>
      </div>
      <div className="rounded-xl border border-[#27272A] bg-black p-4 flex flex-col gap-3">
        <span data-testid="publish-result-link" className="ff-code text-xs text-white break-all">{link}</span>
        {ride.invite_enabled && (
          <span className="text-sm text-[#94A3B8]">PIN: <span data-testid="invite-result-pin" className="ff-code text-white text-base tracking-[0.3em]">{ride.invite_pin}</span></span>
        )}
      </div>
      <WhatsAppButton ride={ride} testid="publish-whatsapp-button" />
      <div className="grid grid-cols-2 gap-2">
        <button type="button" data-testid="publish-copy-link-button" onClick={() => copy(link, "Link copiato")} className="ff-btn-secondary text-sm"><Copy size={16} /> Copia link</button>
        {ride.invite_enabled ? (
          <button type="button" data-testid="invite-copy-pin-button" onClick={() => copy(ride.invite_pin, "PIN copiato")} className="ff-btn-secondary text-sm border-[#3B82F6]"><KeyRound size={16} /> Copia PIN</button>
        ) : (
          <button type="button" data-testid="publish-done-button" onClick={onDone} className="ff-btn-secondary text-sm">Fatto</button>
        )}
      </div>
      {ride.invite_enabled && (
        <button type="button" data-testid="publish-done-button" onClick={onDone} className="h-12 text-sm font-semibold text-[#94A3B8] hover:text-white transition-colors">Chiudi</button>
      )}
    </div>
  );
};
